/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import {Dimensions, Platform, StyleSheet} from 'react-native';

const entireScreenWidth = Dimensions.get('window').width;
const entireScreenHeight = Dimensions.get('window').height;

export default StyleSheet.create({
    container: {
        flex: 1,
        marginBottom: Platform.OS === 'web'? 0: 90,
    },
    listContainer: {
    flex: 1,
    marginTop: 20,
    padding: 20,

    },
    catalogImageAndroid: {
    width: entireScreenWidth / 3.5,
    height: entireScreenHeight / 3.5,
    aspectRatio: 3/4,
    resizeMode: 'contain',
    borderWidth: 2,
    borderColor: "#a8a8a8",
    },
    catalogImage: {
    width: entireScreenWidth / 3.5,
    height: entireScreenHeight / 3.5,
    aspectRatio: 3/4,
    resizeMode: 'contain',
    },
    image: {
    width: 300,
    height: 300,
    aspectRatio: 3/4,
    },
    shadow: {
    shadowOffset: {
    width: 0,
    height: 0,
    },
    shadowOpacity: 50,
    shadowRadius: 10,
    shadowColor: "gray",
    },
    shadowAndroid: {
    borderWidth: 2,
    borderColor: "#a8a8a8"
    },
    catalogTitle: {
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    paddingTop: 16,
    color: 'white',
    },
    catalogDescription: {
    fontSize: 12,
    textAlign: "center",
    paddingTop: 10,
    paddingBottom: 10,
    color: 'white',
    },
    catalogUpdatesHeader: {
    fontSize: 20,
    textAlign: 'center',
    color: 'white',
    marginBottom: 20,
    },
    updateContainerEmpty: {
    marginTop: "3%",
    backgroundColor: 'transparent',
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    },
    viewCatalogButtonContainer: {
    backgroundColor: 'yellow',
    borderRadius: 8,
    margin: 15,
    },
    viewCatalogButtonText: {
    fontSize: 18,
    padding: 10,
    },
          textIcon: {
          height: "auto",
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderWidth: 2,
          borderRadius: 8,
          borderColor: 'white',
          marginTop: "0%",
          marginBottom: "20%",
          marginRight: "5%",
          marginLeft: "5%",
          padding: 10,
          backgroundColor: 'transparent',
          },
          iconText: {
          fontSize: 15,
          textAlign: 'center',
          paddingTop: 10,
          color: "white",
          },
          iconTextEmptyList: {
          fontSize: 14,
          fontWeight: 'bold',
          textAlign: 'center',
          paddingTop: 10,
          color: 'white',
          },
        headerWrapper: {
        position: 'absolute',
		backgroundColor: 'black',
		alignItems: 'center',
		alignSelf: 'center',
		padding: 10,
		width: "100%",
	},
})